export default {
  authErrorPrefix: 'Error al autenticar: ',
  authenticating: 'Autenticando...',
};
